<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'repository.productTypes.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'repository.productTypes.list.add' | translate"
        mat-mini-fab class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-product-type-edit *ngIf="isCreationMode && !editedId"
        (editFinished)="onEditFinished()"></app-product-type-edit>
    </section>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" #input>
    </mat-form-field>

    <section class="datatable-container">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.productTypes.list.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let productType"> {{ productType.name }} </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.productTypes.list.client' | translate }}
          </th>
          <td mat-cell *matCellDef="let productType"> {{ productType.client?.name }} </td>
        </ng-container>

        <ng-container matColumnDef="minimum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.productTypes.list.minimum' | translate
            }} </th>
          <td mat-cell *matCellDef="let productType"> {{ productType.minimum }} </td>
        </ng-container>

        <ng-container matColumnDef="maximum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.productTypes.list.maximum' | translate
            }} </th>
          <td mat-cell *matCellDef="let productType"> {{ productType.maximum }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'repository.productTypes.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let productType">
            <ng-container *ngIf="productType.id !== editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'repository.productTypes.list.edit' | translate" (click)="onEdit(productType.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'repository.productTypes.list.delete' | translate" (click)="delete(productType.id)">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let productType" [attr.colspan]="displayedColumns.length">
            <div *ngIf="productType.id === editedId" class="row-edit"
              [@detailExpand]="productType.id === editedId ? 'expanded' : 'collapsed'">
              <app-product-type-edit [productType]="productType"
                (editFinished)="onEditFinished()"></app-product-type-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator class="paginator" [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>